import Http from './http'
import { ErrorWrapper } from './util'

export default class BaseService {
    /**
    * ------------------------------
    * @HELPERS
    * ------------------------------
    */

    request(status = { auth: true }) {
        return new Http(status)
    }

    errorWrapper(...rest) {
        return new ErrorWrapper(...rest)
    }
}
